module.exports = __webpack_public_path__ + "static/media/Pod-white.5fc525a7.svg";